module.exports = __webpack_public_path__ + "img/17-2.f67e7fda.png";